// @ utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  SECOND_STEP,
  THIRD_STEP
} = require('constants/index');
const hireCardCreditInitINESuccess = (response, contractNumberAccount, creditLimit) => ({
  type: actionTypes.HIRE_CARD_CREDIT_INIT_SUCCESS,
  payload: {
    response,
    contractNumberAccount,
    creditLimit
  },
});
const hireCardCreditInitINEError = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_INIT_ERROR,
  };
};
const hireCardCreditInitDIRError = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_DIR_ERROR,
  };
};
const hireCardCreditInitPolicySuccess = (response) => ({
  type: actionTypes.HIRE_CARD_CREDIT_INIT_POLICY_SUCCESS,
  payload: {
    response,
  },
});
const hireCardCreditInitPolicyError = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_INIT_POLICY_ERROR,
  };
};
const hireCardCreditINESuccess = (base64, documentId) => ({
  type: actionTypes.HIRE_CARD_CREDIT_INE_SUCCESS,
  payload: {
    base64,
    documentId,
  },
});
const hireCardCreditDIRSuccess = (base64, documentId) => ({
  type: actionTypes.HIRE_CARD_CREDIT_DIR_SUCCESS,
  payload: {
    base64,
    documentId,
  },
});
const hireCardCreditINEError = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_INE_ERROR,
  };
};
const hireCardCreditPolicySuccess = (base64, documentId) => ({
  type: actionTypes.HIRE_CARD_CREDIT_POLICY_SUCCESS,
  payload: {
    base64,
    documentId,
  },
});
const hireCardCreditPolicyError = () => {
  return {
    type: actionTypes.HIRE_CARD_CREDIT_POLICY_ERROR,
  };
};
const cardsConfimationScrollDown = () => ({
  type: actionTypes.CARDS_REQUEST_CONFIRM_SCROLL_DOWN,
});
const cardsConfimationScrollDownPolicy = () => ({
  type: actionTypes.CARDS_REQUEST_CONFIRM_SCROLL_DOWN_POLICY,
});
const checkCheckedDocument = () => ({
  type: actionTypes.CARDS_CHECKED_DOCUMENT,
});
const resetInitCardsDocuments = () => ({
  type: actionTypes.RESET_INIT_CARDS_DOCUMENTS,
});
const getDocumentsCardINE = (operationProcessId) => (dispatch, getState) => {
  return APIGet(dispatch, `${apiURLBuilder.getURL('hiringCardsDocuments')}/${operationProcessId}/precontractual/documents`)
    .then(response => {
      const { base64Document, temporaryDocumentId } = response;
      const base64 = base64Document
      const documentId = temporaryDocumentId
      dispatch(hireCardCreditINESuccess(base64, documentId));
    })
    .catch(() => {
      dispatch(hireCardCreditINEError());
    });
}

const getDocumentsCardDIR = (operationProcessId) => (dispatch, getState) => {
  APIGet(dispatch, `${apiURLBuilder.getURL('hiringCardsDocuments')}/${operationProcessId}/dir/documents`)
    .then(response => {
      const { base64Document, temporaryDocumentId } = response;
      const base64 = base64Document
      const documentId = temporaryDocumentId
      dispatch(hireCardCreditDIRSuccess(base64, documentId));
    })
    .catch(() => {
      dispatch(hireCardCreditInitDIRError());
    });
}
const getInitParams = (initCall, immHireCard, product) => (dispatch, getState) => {
  const amount = getState().hireCreditLimit.get('creditLimit');
  const productType = product?.type ? product?.type : getState().hireCreditLimit.get('productType');
  const productSubType = product?.subtype ? product?.subtype : getState().hireCreditLimit.get('productSubType');
  const standard = product?.standard ? product?.standard : getState().hireCreditLimit.get('referenceStandard');
  const tae = getState().revolvingPersistentData.getIn(['paramsInne', 'tae']);
  const taeInit = getState().revolvingPersistentData.getIn(['paramsInne', 'taeInit']);
  const tin = getState().revolvingPersistentData.getIn(['paramsInne', 'tin']);
  const interestRate = Number(tin.replace(/%/g, '').replace(',', '.')) / 100;
  const typePayment = getState().revolvingPersistentData.getIn(['paramsAFI', 'typePayment']);
  const calculationType = getState().revolvingPersistentData.getIn(['paramsAFI', 'calculationType']);
  const calculatePaymentMethod = getState().revolvingPersistentData.getIn(['paramsAFI', 'calculatePaymentMethod']);
  const fixedPaymentAmount = getState().revolvingPersistentData.getIn(['paramsAFI', 'valuePayment']);
  const paymentMethodMap = { "FixedPaymentAmount": "FIXED", "PercentagePaymentRate": "VARIABLE" };
  const paymentMethod = paymentMethodMap[typePayment] || "UNIQUE";
  const calculationTypeMap = { 0: 0, 1: 1 };
  const mappedCalculationType = calculationTypeMap[calculationType] !== undefined ? calculationTypeMap[calculationType] : 3;
  const accountId = immHireCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  const contractNumberAccountPolicy = immHireCard.get('contractNumberAccount')
  const immCardChangePaymentMethod = getState().cardChangeNewPaymentMethod;
  const operationProcessIdsInit = immHireCard.get('operationProcessIdInit') || immCardChangePaymentMethod.get('operationProcessIdInit');

  const dataAfiSimulator = paymentMethod === "FIXED" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    fixedPaymentAmount
  } : paymentMethod === "VARIABLE" ? {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
    returnFlows: false,
    percentagePaymentRate: fixedPaymentAmount
  } : {
    calculationType: mappedCalculationType,
    interestRate: interestRate,
  }
  const params = {
    query:
    {
      product: {
        type: productType,
        subtype: productSubType,
        standard: standard,
      },
      processType: product?.processType ? product?.processType : initCall ? "contract" : "precontractual",
      dataAfiSimulator: dataAfiSimulator,
      tae: taeInit || tae,
      paymentMethod: calculatePaymentMethod ? calculatePaymentMethod : paymentMethod,
      amount: product?.amount ? product?.amount : amount,
      contractNumber: product?.contractNumberAccount,
      contractNumberAccount: product?.contractNumber
        ? product?.contractNumber
        : initCall
          ? (contractNumberAccountPolicy ?? contractNumberAccount)
          : contractNumberAccount
    }
  }

  if (initCall) {
    params.query.attachedEvidences = [...operationProcessIdsInit];
  }

  return params
}
const getInitINEstep = (immHireCard) => (dispatch, getState) => {
  const params = dispatch(getInitParams(false, immHireCard));
  const accountId = immHireCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsPreContractualInit',
    params
  })
    .then((response) => {
      dispatch(hireCardCreditInitINESuccess(response, contractNumberAccount));
      dispatch(getDocumentsCardINE(response.operationProcessId));
    })
    .catch(() => {
      dispatch(hireCardCreditInitINEError());
    });
}

const getInitINEDIRstep = (immHireCard, product, paramsInit) => (dispatch, getState) => {
  const params = paramsInit || dispatch(getInitParams(false, immHireCard, product));
  const creditLimit = getState().hireCreditLimit.get('creditLimit');

  const accountId = immHireCard.getIn(['steps', SECOND_STEP, 'accountId']) || immHireCard.getIn(['steps', THIRD_STEP, 'accountId']);
  const contractNumberAccount = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsPreContractualInit',
    params
  })
    .then((response) => {
      const operationProcessId = response.operationProcessId
      dispatch(hireCardCreditInitINESuccess(response, contractNumberAccount, creditLimit));
      dispatch(getInitDocuments(operationProcessId));
    })
    .catch(() => {
      dispatch(hireCardCreditInitINEError());
    });
}

const getInitDocuments = operationProcessId => async (dispatch, getState) => {
  const endpoints = {
    ine: `${apiURLBuilder.getURL('hiringCardsDocuments')}/${operationProcessId}/precontractual/documents`,
    dir: `${apiURLBuilder.getURL('hiringCardsDocuments')}/${operationProcessId}/dir/documents`,
  };

  const [ineResult, dirResult] = await Promise.allSettled([
    APIGet(dispatch, endpoints.ine),
    APIGet(dispatch, endpoints.dir),
  ]);

  const ineFulfilled = ineResult.status === 'fulfilled';
  const dirFulfilled = dirResult.status === 'fulfilled';

  if (ineFulfilled && dirFulfilled) {
    const { base64Document: ineBase64, temporaryDocumentId: ineDocumentId } = ineResult.value;
    const { base64Document: dirBase64, temporaryDocumentId: dirDocumentId } = dirResult.value;
    dispatch(hireCardCreditINESuccess(ineBase64, ineDocumentId));
    dispatch(hireCardCreditDIRSuccess(dirBase64, dirDocumentId));
  } else {
    if (!ineFulfilled) dispatch(hireCardCreditINEError());
    if (!dirFulfilled) dispatch(hireCardCreditInitDIRError());
  }
};

const getDocumentCardPolicy = (operationProcessId) => (dispatch, getState) => {
  APIGet(dispatch, `${apiURLBuilder.getURL('hiringCardsDocuments')}/${operationProcessId}/contract/documents`)
    .then(response => {
      const { base64Document, temporaryDocumentId } = response;
      const base64 = base64Document
      const documentId = temporaryDocumentId
      dispatch(hireCardCreditPolicySuccess(base64, documentId));
    })
    .catch(() => {
      dispatch(hireCardCreditPolicyError());
    });
}
const getInitPolicystep = (immHireCard, product, paramsInit) => (dispatch, getState) => {
  const params = paramsInit || dispatch(getInitParams(true, immHireCard, product));
  return APIPost({
    dispatch,
    endpoint: 'hiringCardsPreContractualInit',
    params
  })
    .then((response) => {

      dispatch(hireCardCreditInitPolicySuccess(response));
      dispatch(getDocumentCardPolicy(response.operationProcessId))
    })
    .catch(() => {
      dispatch(hireCardCreditInitPolicyError());
    });
}
const getInitCardsDocuments = (immHireCard) => (dispatch, getState) => {
  dispatch(resetInitCardsDocuments());
  dispatch({ type: actionTypes.HIRE_CARD_CREDIT_CARD_RESET_INIT_SEND_EMAIL })
}

module.exports = {
  getInitINEstep,
  getInitPolicystep,
  cardsConfimationScrollDown,
  checkCheckedDocument,
  cardsConfimationScrollDownPolicy,
  getInitCardsDocuments,
  getInitINEDIRstep,
  resetInitCardsDocuments
};
